var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_735_2525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0033 13.1253L22.5441 16.6015C26.8505 13.2095 26.8505 9.55475 26.8505 9.55475L21.1362 15.1093C24.9821 8.82716 23.5743 6.24023 23.5743 6.24023L19.0228 13.8091C18.0242 13.5379 16.9953 13.4009 15.9618 13.4015H15.889C14.8555 13.4009 13.8265 13.5379 12.8281 13.8091L8.27648 6.24023C8.27648 6.24023 6.68309 8.61497 10.5291 14.8971L5.0102 9.55475C5.0102 9.55475 4.44704 12.8019 9.04831 16.3994C9.02511 16.4364 3.84415 13.1253 3.84415 13.1253C3.84415 13.1253 3.71164 16.2444 8.27648 18.7471V18.8281C8.27648 22.2201 11.6786 25.7231 15.8956 25.7602H15.9685C20.1788 25.7231 23.5876 22.2201 23.5876 18.8281V18.7471C28.1359 16.2444 28.0033 13.1253 28.0033 13.1253ZM13.3482 22.2369C13.3482 22.2369 11.9966 22.3244 11.2181 21.5329C10.4396 20.7414 10.5357 19.3703 10.5357 19.3703C10.5357 19.3703 11.8873 19.2794 12.6657 20.0743C13.4442 20.8692 13.3482 22.2369 13.3482 22.2369ZM20.6359 21.5329C19.8575 22.3244 18.5093 22.2369 18.5093 22.2369C18.5093 22.2369 18.4231 20.8658 19.2017 20.0743C19.9801 19.2828 21.3284 19.3703 21.3284 19.3703C21.3284 19.3703 21.4045 20.7414 20.6228 21.5329H20.6359Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_735_2525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalot);
export default __webpack_public_path__ + "static/media/talot.7b09da91206ad0e257593343b2715e80.svg";
export { ForwardRef as ReactComponent };